import * as React from 'react';
import { useGetContractorUserQuery } from "../../../apis/ContractorUser.api";
import { PrimaryContractorUser, ContractorUser } from "../../../types/models/ContractorUser";
import {displayDateTime, displayDate, displayTime} from "../../../../utils/formatDate";

type IDisplayProps = {
    data: ContractorUser;
};

export const ContractorUserNameDisplay: React.FC<IDisplayProps> = ({data}) => {
    if (data) {
        return (<>{ data?.email }
                    {data?.name && <> | </> }{ data?.name }
                    </>)
    } else {
        return undefined
    }
}

type INameProps = {
    id: ID;

};

const ContractorUserName: React.FC<INameProps> = ({id}) => {
    const { data } = useGetContractorUserQuery(PrimaryContractorUser.fromId(id))
    return (<ContractorUserNameDisplay data={data}/>)
}

export default ContractorUserName;
